<idp-widget-tabs
  *ngIf="bookingTabFacade.bookingTabDetails$ | ngrxPush as content"
  [content]="content"
  [bookingTab]="(bookingTabFacade.bookingTab$ | ngrxPush) || ''"
  (externalLinkEmit)="externalLinkClicked($event)"
  (externalLinkTracking)="onExternalLinkTracking($event)"
  (tabSelectEmit)="tabSelectClicked($event)"
  (tabClickTracking)="onTabClickTracking($event)"
  (analyticsEvent)="handleAnalytics($event)"
></idp-widget-tabs>
